__turbopack_context__.v({
  "btn": "CookiePopup-module-scss-module__yJJBBG__btn",
  "container": "CookiePopup-module-scss-module__yJJBBG__container",
  "text": "CookiePopup-module-scss-module__yJJBBG__text",
});
